var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 4.49999V8.5L10.6667 9.83333M14.6667 8.5C14.6667 12.1819 11.6819 15.1667 8.00004 15.1667C4.31814 15.1667 1.33337 12.1819 1.33337 8.5C1.33337 4.8181 4.31814 1.83333 8.00004 1.83333C11.6819 1.83333 14.6667 4.8181 14.6667 8.5Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.d1492b55.svg";
export { ForwardRef as ReactComponent };